'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Item": "Polaris-FormLayout__Item",
  "grouped": "Polaris-FormLayout--grouped",
  "condensed": "Polaris-FormLayout--condensed"
};

exports.default = styles;
